'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CssProvider = function (_Component) {
    (0, _inherits3.default)(CssProvider, _Component);

    function CssProvider(props) {
        (0, _classCallCheck3.default)(this, CssProvider);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CssProvider.__proto__ || (0, _getPrototypeOf2.default)(CssProvider)).call(this, props));

        _this.styles = [];
        return _this;
    }

    (0, _createClass3.default)(CssProvider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            // Hot reloading the rules (since rules might have new START, END, etc...)
            if (module.hot) {
                module.hot.addStatusHandler(_lodash2.default.debounce(function () {
                    if (!window.wssSerialize) {
                        var css = _lodash2.default.map((0, _jquery2.default)('style[data-computed!=true]'), function (style) {
                            return (0, _jquery2.default)(style).text().split('\n').join(' ');
                        }).join(' ');
                        _this2.props.wss.update({ css: css });
                        _lodash2.default.each(_this2.styles || [], function (ss) {
                            return ss.remove();
                        });
                        _this2._updateStyles();
                    } else {
                        fetch(window.prodAppFile.replace(/\.js/, '.css')).then(function (r) {
                            return r.text();
                        }).then(function (css) {
                            _lodash2.default.each(_this2.styles || [], function (ss) {
                                return ss.remove();
                            });
                            _this2.props.wss.update({ css: css });
                            _this2._updateStyles();
                        });
                    }
                }, 500));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            this._updateStyles();

            return this.props.children;
        }
    }, {
        key: '_updateStyles',
        value: function _updateStyles() {
            var _props = this.props,
                styles = _props.styles,
                i18n = _props.i18n,
                wss = _props.wss;


            if (!styles.styles) return null;

            var colors = styles.styles.colors || {};
            var fonts = styles.styles.fonts || {};
            var numbers = styles.styles.numbers || {};

            // i18n.i18n.isRtlDir - Getting i18n from the state instead of the provider
            var isRtl = typeof i18n.isRtlDir === 'function' ? i18n.isRtlDir() : i18n.i18n.isRtlDir();

            var css = wss.get({ colors: colors, fonts: fonts, numbers: numbers, isRtl: isRtl });

            _lodash2.default.each(this.styles || [], function (ss) {
                return ss.remove();
            });

            this.styles = [];

            var ss = (0, _jquery2.default)('<style data-computed=\'true\'>').text(css).appendTo((0, _jquery2.default)('head'));

            this.styles = [ss];
        }
    }, {
        key: 'getChildContext',
        value: function getChildContext() {
            var styles = this.props.styles;


            return {
                wss: {
                    getColor: function getColor(key) {
                        if (styles.styles) {
                            return styles.styles.colors[key];
                        } else {
                            return 'white';
                        }
                    }
                }
            };
        }
    }]);
    return CssProvider;
}(_react.Component);

CssProvider.displayName = 'CssProvider';

CssProvider.childContextTypes = {
    wss: _propTypes2.default.object
};

function mapStateToProps(state) {
    var result = {
        styles: state.styles
    };

    if (state.i18n) {
        // Backwards compatibility. Should be removed, now using I18nProvider
        result.i18n = state.i18n;
    }

    return result;
}

function mapDispatchToProps() {
    return {};
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CssProvider);